export default "__VITE_ASSET__5fLwufcG__"